import Grid from '@material-ui/core/Grid'
import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'

const styles = () => ({
  container: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  message: {
    float: 'right',
    color: '#777777',
    marginTop: '10px',
    fontSize: '14px'
  }
})

const Message = ({ classes }) => {
  return (
    <Grid className={classes.container}>
      <div className={classes.message}>
        *Revisar condiciones en la Consultoría vigente del ciclo.
      </div>
      <div className={classes.message}>
        **A la ganancia (comisión) señalada, se le deberá descontar el IVA y demás impuestos que correspondan deducir. 
      </div>
      <div className={classes.message}>
        ***Para productos de Casa y Estilo el descuento es de 18%, independiente del nivel.
      </div>
    </Grid>
  )
}



export const DisclaimerMessage = withStyles(styles)(Message)
